// Filename - pages/Support.js

import React from "react";

const CreditManagement = () => {
    return (
        <div className="CreditManagement">
        </div>
    );
};

export default CreditManagement;
